module.exports = __webpack_public_path__ + "static/media/bath-fill.1f39fcc3.svg";